<template>
    <!-- アプリ情報 -->
    <fieldset id="mobileAppKind">
        <legend>モバイルアプリ種別:</legend>
        <div>
            テスト対象のモバイルアプリ種別を選択してください。
        </div>
        <div class="form-area">
            <label for="appKind">・対象アプリ種別</label><br>
            <input type="radio" class="input-app-kind-radio" id="apkFile" v-model="selectedAppKind"
                name="appKindRadio" value="apkFile" @change="updateAppKind">
            <label for="apkFile">APKファイル</label><br>
            <input type="radio" class="input-app-kind-radio" id="appPackage" v-model="selectedAppKind"
                name="appKindRadio" value="appPackage" @change="updateAppKind">
            <label for="appPackage">インストール済みアプリ</label><br>
        </div>
    </fieldset>
</template>

<script>
import { onMounted, ref } from 'vue';

export default {
    name: 'MobileAppKindForm',
    setup(_, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        const selectedAppKind = ref("apkFile");

        // #############
        // コマンド生成 #
        // #############
        const updateAppKind = (event) => 
        {
            const selecteedValue = event.target.value
            emit("select-app-kind", selecteedValue)
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            updateAppKind({ target: { value: 'apk_file' } }) 
        })

        return {
            selectedAppKind,
            // フォームデータ
            updateAppKind,
        }
    }
}
</script>
